// In-memory registry for optional runtime feature modules.
// Feature bundles call `registerRuntimeFeature(...)` after lazy load.
import type { LuisRuntimeFeatureMap, LuisRuntimeFeatureName } from './types'

const runtimeFeatures: Partial<LuisRuntimeFeatureMap> = {}

// Register one runtime feature API implementation.
export function registerRuntimeFeature<Name extends LuisRuntimeFeatureName>(
  name: Name,
  feature: LuisRuntimeFeatureMap[Name],
): void {
  runtimeFeatures[name] = feature
}

// Resolve one runtime feature API when loaded.
export function getRuntimeFeature<Name extends LuisRuntimeFeatureName>(
  name: Name,
): LuisRuntimeFeatureMap[Name] | undefined {
  // Return registered feature API if present.
  return runtimeFeatures[name] as LuisRuntimeFeatureMap[Name] | undefined
}

// Check whether one runtime feature is already registered.
export function hasRuntimeFeature(name: LuisRuntimeFeatureName): boolean {
  // Return true when feature API exists in registry.
  return Boolean(runtimeFeatures[name])
}
